import { memo, useCallback } from "react";

import { TextField } from "ui/components/TextField/TextField";

import { initialCronJobExecutionLogSearchForm } from "services/api/cronjobs/consts";
import { CronJobExecutionLogSearchFormValues } from "services/api/cronjobs/types";

interface CronJobExecutionLogsFiltersProps {
  formValues: CronJobExecutionLogSearchFormValues;
  onSearchChange: (values: CronJobExecutionLogSearchFormValues) => void;
}

const CronJobExecutionLogsFilters: React.FC<CronJobExecutionLogsFiltersProps> = (props) => {
  const { formValues, onSearchChange } = props;

  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onSearchChange({ ...formValues, search: e.target.value });
    },
    [formValues, onSearchChange]
  );

  const handleResetFormClick = useCallback(() => {
    onSearchChange(initialCronJobExecutionLogSearchForm);
  }, [onSearchChange]);

  return (
    <div className="flex flex-wrap items-center gap-3">
      <TextField
        type="text"
        name="search"
        value={formValues.search}
        onChange={handleSearchChange}
        placeholder="Pretraži log…"
        startIcon="../media/icons/search.svg"
        cssClassName="bg-white"
      />
      <span
        onClick={handleResetFormClick}
        className="text-xs font-bold cursor-pointer text-gray-700"
      >
        Poništi
      </span>
    </div>
  );
};

export default memo(CronJobExecutionLogsFilters);
